import {Component, React} from '$src/handy'
import {observer, Observer} from 'mobx-react'
import {Route, Redirect, RouteProps} from 'react-router'

export default class LoggedInOnlyRoute extends Component<RouteProps & {component: React.ComponentType}, {}> {
  render() {
    const {component, ...rest} = this.props
    return (
      <Route
        {...rest}
        render={(props: any) => {
          return <Observer>{() => {
            return this.store.auth.getState().isLoggedIn ? (
              React.createElement(component, props)
            ) : (
              <Redirect to={{pathname: '/'}} />
            )
          }}</Observer>

        }}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/bootstrap/routing/LoggedInOnlyRoute.tsx